@import 'src/styles/common/_colors.scss';


.facilityInfo {
    height: 60px;
    cursor: pointer;
}

.facilityInfo p {
    line-height: 16px;
    color: $gray-variant-10;
    padding: 3px 0 0 5px;
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.bottomPanel {
	border-top: 1px $my-views-group-block-rule-divider-color solid;
	width:100%;
	display: flex;
	align-items: center;
	height: 30px;
	padding-right: 4px;
	&__item {
		float: left;
		position: relative;
	}
	.loader{
		margin-left:0.25rem;
	}

	.divider {
		border-left: 1px $my-views-group-block-rule-divider-color solid;
		float: left;
		height: 25px;
		margin: 4px 2px;
	}

	.connectivityStatus,
	.remoteAccessStatus {
		float: left;
		margin: 9px 5px;
	}
}


.info {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    align-items: flex-start;
    padding-right: 3px;
}


.title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
	position: relative;
    height: 26px;
	padding: 3px 5px;
	background: linear-gradient(to bottom, $mightnight-black 0%,$black 100%);
	border: 1px solid $gray-variant-1;
	cursor: default;
	white-space: nowrap;
	text-overflow: ellipsis;
	line-height: 18px;
    span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: keep-all;
        cursor: pointer;
        font-weight: bold;
        text-transform: uppercase;
        color: $white;
    }
    input[type="checkbox"] {
        left: 0;
        margin-right: 4px;
    }
}

.partially-connected {
	background: linear-gradient(to bottom,  $dark-green-variant 0%,$gray-variant-2 50%,$gray-variant 51%,$gray-variant-3 100%);
}

.not-connected {
	background: linear-gradient(to bottom,  $gray-variant-1 0%,$gray-variant-2 50%,$gray-variant 51%,$gray-variant-3 100%);
}

.connected {
	border-color: $dark-green-variant-3;
	background: linear-gradient(to bottom,  $dark-green-variant-1 0%,$dark-green-variant-2 100%); /* W3C */
}

.partially-connected {
	background: repeating-linear-gradient(
		-45deg,
		$gray-variant-11,
		$gray-variant-11 1px,
		$gray-variant-10 1px,
		$gray-variant-10 2px
	);
	border-color: $gray-variant-9;
}


.offer {
	margin-left: 3px;
	flex: 0 0 auto;
	position: relative;
}
.offer__shortName {
	cursor: pointer;
	text-align: center;
	height: 19px;
	line-height: 17px;
	margin: 6px 2px;
	padding: 0 4px;
	border: 1px solid $lightgray;
	background-color: $light-gray-variant-1;
}



.offer .expired {
		color: $light-red;
}
	
.offer .offer__shortName.expired {
		background-color: $red;
		border-color: $dark-red;
		color: $white;
}

.searchHighlightColor {
	background-color: $text-highlight;
	color: $white;
}

.rightAligned{
	display: flex;
	flex: 1 1 auto;
}

.showMore{
	background: transparent;
	border: none;
	&:hover{
		text-decoration: underline;
	}
}

.offerInfoWrapper {
	display: flex;
    justify-content: flex-start;
	gap: 3px;
}
.expandedOfferingInfo {
	padding: 4px 4px;
	background-color: $tile-white;
    border: 1px solid $light-gray-variant-1;
    box-shadow: 0 0 4px 0 $label;
    position: absolute;
    top: 101%;
    left: 0;
    width: auto;
	z-index: 2;
}